export default {
    bindings: {
        error: '<'
    },
    controller: 'adminPaymentErrorsController',
    template: require('../views/admin.payment.errors.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/admin.payment.errors.component.js